/* global exports */
"use strict";

var ToPs = require("../../client/js/components/JsToPs").default;
var RestaurantHours =  require('../../client/js/components/RestaurantHours').default;
var RestaurantHoursPS = ToPs(RestaurantHours);

exports.init = RestaurantHoursPS.init;
exports.update = RestaurantHoursPS.update;
